// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mXXb","colBig":"styles_colBig__3t7S4","colSmall":"styles_colSmall__3acHr"};